import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './app/environments/environment';
import { captureBootstrapError, initCommoSentry } from './app/sentry';

initCommoSentry(environment);

bootstrapApplication(App, appConfig).catch((err: unknown) => {
  captureBootstrapError(err);
  throw err;
});
